$(window).on('load',function() {

  //Masonry system for the articles.
  $('.grid').isotope({
    // set itemSelector so .grid-sizer is not used in layout
    itemSelector: '.grid-item',
    percentPosition: true,
    filter: '*',
    masonry: {
      // use element for option
      columnWidth: '.grid-sizer'
    }
  });

  if (window.location.href.indexOf("?") > -1) {
    var a = location.href; 
    var b = a.substring(a.indexOf("?")+1);
  }

  //Filtering the articles.
  $(".filter").on("click",function(){
    $(".filter").removeClass("active");
    var myFilter = $(this).attr("data-filter");
    $('.grid').isotope({ filter: myFilter });
    $(this).addClass("active");
  });
  if(b){
    $(".filter."+b).click();
    setTimeout(function(){ 
      $(".realisations .head-section .container").css("opacity","1");
      $(".realisations").css("background-image","none");
    }, 300);
  }
  else{
    $(".realisations .head-section .container").css("opacity","1");
    $(".realisations").css("background-image","none");
  }

});
